export const environment = {
  production: false,
  title:'Test environment',
  hostURL:'https://wwwtest.fedex.com',
  apiURL:'https://test.fdmpnoptout.fedex.com',
  host:'wwwtest.fedex.com',
  apigURL:'apitest.fedex.com'
};

